<template>
    <div class="travel-quote-step choose-dates">
        <quote-step-header
            :title="subStepFields.title"
            :key="currentSubStep"
            :subtitle="subStepFields.subtitle"
        />
        <form class="quote-form" @submit.prevent="next">
            <div class="form-row">
                <div>

                    <app-label>
                        {{ trans("labels.birth_date") }}
                    </app-label>

                    <date-input
                        v-model="form[stepName].birth_date"
                        :typeable="true"
                        icon="calendar_new"
                        manual
                        @input="validateDate"
                    />

                    <div v-if="showErrorMessage" class="error-message">
                        {{ trans("pet_date_validation_error") }}                    </div>
                </div>
            </div>
            <div class="form-row second-row">
                <div>
                    <app-label>
                        {{ trans("labels.pet_name") }}
                    </app-label>
                    <app-input v-model="form[stepName].name"/>

                </div>
                <div>
                    <app-label>
                        {{ trans("labels.pet_color") }}
                    </app-label>
                    <app-input v-model="form[stepName].color"/>
                </div>
            </div>

            <div class="submit-row">
                <app-button
                    :disabled="disabledConditions"
                    :loading="loading"
                >
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";
import AppButton from "../../Forms/Button.vue";
import DateInput from "../../Forms/DateInput.vue";


export default {
    components: {AppButton, DateInput},
    mixins: [QuoteStep],
    data() {
        return {
            showErrorMessage: false,
            subSteps: ["default"]
        };
    },
    methods: {
        validateDate() {
            const currentDate = new Date();
            const inputDate = new Date(this.form[this.stepName].birth_date);

            const differenceInMilliseconds = currentDate - inputDate;
            const differenceInYears = differenceInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);
            const differenceInMonths = differenceInMilliseconds / (1000 * 60 * 60 * 24 * 30);

            this.showErrorMessage = differenceInYears > 8 || differenceInMonths < 3;
        }
    },
    computed: {
        canMoveNext() {
            return (
                this.form[this.stepName].birth_date &&
                this.form[this.stepName].name &&
                this.form[this.stepName].color &&
                !this.showErrorMessage
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.quote-form {
    .form-row {
        flex-direction: row;
        justify-content: space-between;

        &.second-row {
            margin: 40px 0;

            > div {
                width: 45%;

                @media (max-width: $tablet) {
                    width: 100%;
                }
            }
        }

        > div {
            width: 100%;
        }

        .app-label-wrapper {
            margin-bottom: 10px;
        }

        ::v-deep {
            .masked-date-input {

                width: 100%;
                border-radius: 100px;
                border: 1px solid rgba(33, 67, 146, 0.2);
                background: $lightest-gray;
                height: 50px;
                margin: unset;
            }
        }


        @media (max-width: $tablet) {
            flex-direction: column;

            > div {
                width: 100%;
            }
        }
    }
    .error-message {
        color: $error-red;
        font-size: 12px;
    }
}
</style>
